<template>
    <rkm-area
        no-margin-top
        title="Motivos do atendimento"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.subjetivo.motivos"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => `${item.ciap.codigo} - ${item.ciap.descricao}`"
                                    label="CIAP 2"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:collapse="{item}">
                        <rkm-row class="p-2">
                            <rkm-col>
                                <Item :get-value="() => item.observacao" />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>